module.exports = __webpack_public_path__ + "img/weituo.a0815c1b.png";